import { FC } from 'react';
import { TOKENS, SeverityLevel } from './tokens';

type Props = {
  value: number | string;
  label: string;
  tone?: SeverityLevel | 'neutral';
  size?: 'sm' | 'lg';
  onClick?: () => void;
};

// Big number + small label tile. Used in the dashboard hero ("Alta · 5",
// "Média · 7", "OK · 135") and reusable wherever a single KPI needs
// emphasis. Color comes from the severity palette; pass `neutral` to use
// muted gray on a plain card.
export const StatBlock: FC<Props> = ({ value, label, tone = 'neutral', size = 'lg', onClick }) => {
  const palette = tone === 'neutral'
    ? { bg: TOKENS.color.surface, text: TOKENS.color.text, label: TOKENS.color.muted }
    : { bg: TOKENS.color.severity[tone].bg, text: TOKENS.color.severity[tone].text, label: TOKENS.color.severity[tone].text };

  const numberSize = size === 'lg' ? TOKENS.typography.kpiLarge.size : TOKENS.typography.kpiSmall.size;

  return (
    <div
      onClick={onClick}
      style={{
        background: palette.bg,
        borderRadius: TOKENS.radius.card,
        padding: `${TOKENS.spacing.md}px ${TOKENS.spacing.lg}px`,
        textAlign: 'center',
        cursor: onClick ? 'pointer' : undefined,
      }}
    >
      <div style={{ fontSize: numberSize, fontWeight: 700, color: palette.text, lineHeight: 1 }}>
        {value}
      </div>
      <div
        style={{
          fontSize: TOKENS.typography.label.size,
          fontWeight: TOKENS.typography.label.weight,
          textTransform: TOKENS.typography.label.transform,
          letterSpacing: TOKENS.typography.label.tracking,
          color: palette.label,
          marginTop: TOKENS.spacing.xs,
        }}
      >
        {label}
      </div>
    </div>
  );
};
